<template>
  <div>
    <div class="row row-header ml-4 justify-content-center">
      <div class="col-4 col-header text-danger text-left">
        Reimburse
      </div>
      <div class="col-2 col-header text-danger text-right">
        Total Receipts
      </div>
      <div class="col-2 col-header text-danger text-right">
        Amount
      </div>
    </div>
    <div
      class="row row-data ml-4 justify-content-center"
      v-for="summ in reimbursementSummaries"
      :key="summ.PayerName"
    >
      <div class="col-4">
        {{ summ.PayerName }}
      </div>
      <div class="col-2 text-right">
        {{ summ.Receipts }}
      </div>
      <div class="col-2 pl-0 pr-0">
        {{ currencyFormatter(summ.Amount) }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ReportReimbursementSummary',
  props: {
    reimbursementSummaries: {
      type: Array,
      default: function () {
        return []
      }
    }
  }
}
</script>
